import {
  ROLES,
  UPDATE_ROLE,
  CREATE_ROLE,
  DELETE_ROLE
} from './constants'
import {
  serviceAccountSuccessCallback,
  serviceAccountErrorCallback
} from 'api/callbacks'

export function getRoles () {
  return axios.get(ROLES, {withCredentials: false})
    .then(serviceAccountSuccessCallback)
    .catch(serviceAccountErrorCallback)
}

export function updateRole (roleId, params) {
  return axios.put(UPDATE_ROLE(roleId), params)
    .then(serviceAccountSuccessCallback)
    .catch(serviceAccountErrorCallback)
}

export function createRole (params) {
  return axios.post(CREATE_ROLE, params)
    .then(serviceAccountSuccessCallback)
    .catch(serviceAccountErrorCallback)
}

export function deleteRole (roleId) {
  return axios.delete(DELETE_ROLE(roleId))
    .then(serviceAccountSuccessCallback)
    .catch(serviceAccountErrorCallback)
}



// WEBPACK FOOTER //
// ./app/api/employees/role/role.js